import { render } from "./adminfooter.vue?vue&type=template&id=27342883"
import script from "./adminfooter.vue?vue&type=script&lang=js"
export * from "./adminfooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__